module.exports = __webpack_public_path__ + "img/screen-img-01.8c99b0cc.webp";